module.exports = __webpack_public_path__ + "img/c-resume.1dc01637.png";